import { render, staticRenderFns } from "./ErrorDeclined.vue?vue&type=template&id=4c6c8e25&"
import script from "./ErrorDeclined.vue?vue&type=script&lang=ts&"
export * from "./ErrorDeclined.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports